var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiMapActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 4.16666L7.49996 1.66666L12.5 4.16666L17.7525 1.91583C17.8159 1.88865 17.885 1.87764 17.9537 1.88378C18.0224 1.88993 18.0886 1.91304 18.1461 1.95103C18.2037 1.98903 18.251 2.04073 18.2836 2.1015C18.3163 2.16226 18.3334 2.23018 18.3333 2.29916V15.8333L12.5 18.3333L7.49996 15.8333L2.24746 18.0842C2.18405 18.1113 2.11489 18.1224 2.04618 18.1162C1.97747 18.1101 1.91136 18.087 1.85378 18.049C1.79621 18.011 1.74896 17.9593 1.7163 17.8985C1.68363 17.8377 1.66656 17.7698 1.66663 17.7008V4.16666ZM13.3333 16.1625L16.6666 14.7342V4.19416L13.3333 5.6225V16.1625ZM11.6666 16.0533V5.61333L8.33329 3.94666V14.3867L11.6666 16.0533ZM6.66663 14.3775V3.8375L3.33329 5.26583V15.8058L6.66663 14.3775Z",
    fill: "#042058"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiMapActive);
export default __webpack_public_path__ + "static/media/ri_map_active.0d3896edd76bd9647a32f64c5adef2e5.svg";
export { ForwardRef as ReactComponent };